export function utcTimestampToLocalTime(timestamp, hms) {
  var date = new Date(timestamp);//The timestamp is 10 digits*1000, and the timestamp is 13 digits, no need to multiply 1000
  var Y = date.getFullYear() + '-';
  var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
  var D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
  var h = (date.getHours() < 10 ? '0' + (date.getHours()) : date.getHours());
  var m = (date.getMinutes() < 10 ? '0' + (date.getMinutes()) : date.getMinutes());
  var s = (date.getSeconds() < 10 ? '0' + (date.getSeconds()) : date.getSeconds());
  if (hms == 1) {
      return Y + M + D + ' ' + h + ':' + m + ':' + s;
  } else if (hms == 2) {
      return Y + M + D + ' ' + h + ':' + m;
  }
  return Y + M + D;
}

export function localTimestampToUtcTime(timestamp, hms) {
  var date = new Date(timestamp);//The timestamp is 10 digits*1000, and the timestamp is 13 digits, no need to multiply 1000
  var Y = date.getUTCFullYear() + '-';
  var M = (date.getUTCMonth() + 1 < 10 ? '0' + (date.getUTCMonth() + 1) : date.getUTCMonth() + 1) + '-';
  var D = (date.getUTCDate() < 10 ? '0' + (date.getUTCDate()) : date.getUTCDate());
  var h = (date.getUTCHours() < 10 ? '0' + (date.getUTCHours()) : date.getUTCHours());
  var m = (date.getUTCMinutes() < 10 ? '0' + (date.getUTCMinutes()) : date.getUTCMinutes());
  var s = (date.getUTCSeconds() < 10 ? '0' + (date.getSeconds()) : date.getUTCSeconds());
  if (hms == 1) {
      return Y + M + D + ' ' + h + ':' + m + ':' + s;
  } else if (hms == 2) {
      return Y + M + D + ' ' + h + ':' + m;
  }
  return Y + M + D;
}

// Date pickers select local calendar days; preserve that timezone before UTC conversion.
export function localOrderDayBoundary(timestamp, endOfDay = false) {
  if (!timestamp) return '';
  const date = new Date(timestamp);
  if (!Number.isFinite(date.getTime())) return '';
  date.setHours(endOfDay ? 23 : 0, endOfDay ? 59 : 0, endOfDay ? 59 : 0, 0);
  return localTimestampToUtcTime(date, 1) + (endOfDay ? '.999999' : '');
}

export function changeFlowUnit(flow){
  let flowulength = Math.floor(flow).toString().length;
  if( 0 <= flowulength && flowulength <= 3){
    flow = (flow).toFixed(2) + 'M'
  }else if( 3 < flowulength && flowulength <= 6){
    flow = (flow / 1000).toFixed(2) + 'G'
  }else if(6 < flowulength){
    flow = (flow / 1000000).toFixed(2) + 'T'
  }
  return flow
}
// Order traffic is stored in MB; order-list units use 1024 MB/GB and 1024 GB/TB.
export function formatOrderTraffic(megabytes) {
  const value = Number(megabytes);
  if (!Number.isFinite(value) || value < 0) return '--';
  if (value >= 1024 * 1024) return (value / (1024 * 1024)).toFixed(2) + 'T';
  if (value >= 1024) return (value / 1024).toFixed(2) + 'G';
  return value.toFixed(2) + 'M';
}
